import React from 'react';
import styles from './hover-menu-separator.module.scss';

const HoverMenuItemSeparator = () => <li className={styles.separator} />;

export default HoverMenuItemSeparator;
